"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDTH = exports.TRANSLATION = exports.SIZES = exports.PATH_POSITION = exports.COLOR = void 0;
var SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
exports.SIZES = SIZES;
var WIDTH = {
  small: 100,
  medium: 150,
  large: 200
};
exports.WIDTH = WIDTH;
var PATH_POSITION = {
  small: {
    start: 2,
    end: 98,
    stop1: 50,
    stop2Start: 25.5,
    stop2End: 72
  },
  medium: {
    start: 2,
    end: 148,
    stop1: 75,
    stop2Start: 44,
    stop2End: 105
  },
  large: {
    start: 2,
    end: 198,
    stop1: 100,
    stop2Start: 60,
    stop2End: 137
  }
};
exports.PATH_POSITION = PATH_POSITION;
var COLOR = {
  TEXT_COLOR: 'greyDark',
  SVG_COLOR: 'greyMedium'
};
exports.COLOR = COLOR;
var TRANSLATION = {
  nonStop: 'Non stop',
  singleStop: '1 stop',
  multiStop: '{stop} stops',
  hour: 'h',
  minute: 'm'
};
exports.TRANSLATION = TRANSLATION;